import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaAngleLeft } from "react-icons/fa";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "../../../components/common/css/campaignview.scss";
import "../../new/new.scss";
import { DataGrid } from "@mui/x-data-grid";

const Viewinvestment = () => {
  const navigate = useNavigate();
  const id = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [suitabilityData, setSuitabilityData] = useState([]);
  const [suitabilityStatus, setSuitabilityStatus] = useState("");
  const [suitabilityLoading, setSuitabilityLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const fetchjobData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-myinvestment-details-by-id",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.suitabilityId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data.data.rows[0]);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const fetchSuitabilityData = () => {
    const token = localStorage.getItem("accessToken");
    setSuitabilityLoading(true);

    // Get user ID from the data if available

    var config = {
      method: "get",
      url:
        process.env.REACT_APP_API +
        `investorProfile/suitability-assestment-result?investment_id=${
          id?.suitabilityId
        }&forAdmin=${true}`,
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        setSuitabilityLoading(false);
        setSuitabilityData(response?.data?.data || []);
        setSuitabilityStatus(response?.data?.result || "");
      })
      .catch(function (error) {
        setSuitabilityLoading(false);
        console.error("Error fetching suitability data:", error);
        Swal.fire({
          title: "Error loading suitability test data",
          text: error.response?.data?.message || "Something went wrong",
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const fetchUsers = () => {
    const token = localStorage.getItem("accessToken");
    setUsersLoading(true);

    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-users-by-role",
      headers: {
        "x-access-token": token,
        Accept: "application/json, text/plain, */*",
      },
    };

    axios(config)
      .then(function (response) {
        setUsersLoading(false);
        setUsers(response.data.data.users || []);
      })
      .catch(function (error) {
        setUsersLoading(false);
        console.error("Error fetching users:", error);
        Swal.fire({
          title: "Error loading users",
          text: error.response?.data?.message || "Something went wrong",
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchjobData();
    fetchUsers();
  }, []);

  // Fetch suitability data after main data is loaded
  useEffect(() => {
    if (data && (data.user_id || data.user?.id)) {
      fetchSuitabilityData();
    }
  }, [data]);

  const handleApprove = async () => {
    if (!selectedStatus) {
      Swal.fire({
        title: "Please select an approver",
        text: "You must select an approver before approving",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      setApproveLoading(true);

      // Find the selected user details
      const selectedUser = users.find(
        (user) => user.id.toString() === selectedStatus
      );

      // You can customize this API endpoint based on your requirements
      const response = await axios.post(
        process.env.REACT_APP_API + "admin/send-suitability-status-email",
        {
          investmentId: id.suitabilityId,
          email: selectedUser?.email || "",
          status: "approved",
          user_id: selectedUser?.id,
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        setApproveLoading(false);
        Swal.fire({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/suitability-overview");
        // Refresh the data
        fetchjobData();
        fetchSuitabilityData();
      }
    } catch (error) {
      setApproveLoading(false);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleReject = async () => {
    if (!selectedStatus) {
      Swal.fire({
        title: "Please select an approver",
        text: "You must select an approver before rejecting",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      setRejectLoading(true);

      // Find the selected user details
      const selectedUser = users.find(
        (user) => user.id.toString() === selectedStatus
      );

      // Call the same API with status as "rejected"
      const response = await axios.post(
        process.env.REACT_APP_API + "admin/send-suitability-status-email",
        {
          investmentId: id.suitabilityId,
          email: selectedUser?.email || "",
          status: "rejected",
          user_id: selectedUser?.id,
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        setRejectLoading(false);
        Swal.fire({
          title: "Suitability Test Rejected",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/suitability-overview");
        // Refresh the data
        fetchjobData();
        fetchSuitabilityData();
      }
    } catch (error) {
      setRejectLoading(false);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Reusable style function
  const getStatusBoxStyle = (type) => {
    const baseStyle = {
      padding: "15px",
      borderRadius: "4px",
      marginBottom: "20px",
      fontSize: "14px",
      fontWeight: "500",
      width: "50%",
      maxWidth: "700px",
    };

    if (type === "accept") {
      return {
        ...baseStyle,
        backgroundColor: "#d4edda",
        border: "1px solid #c3e6cb",
        color: "#155724",
      };
    }

    if (type === "reject") {
      return {
        ...baseStyle,
        backgroundColor: "#f8d7da",
        border: "1px solid #f5c6cb",
        color: "#721c24",
      };
    }

    if (type === "pending") {
      return {
        ...baseStyle,
        backgroundColor: "#fff3cd",
        border: "1px solid #ffeeba",
        color: "#856404",
      };
    }

    return baseStyle;
  };

  const fetchStabilityHistoryData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/history-suitability",
      headers: {
        "x-access-token": token,
      },
      data: {
        page: pageState.page,
        limit: pageState.pageSize,
        investmentId: id.suitabilityId,
      },
    };

    axios(config)
      .then(function (response) {
        setPageState((old) => ({
          ...old,
          data: response?.data?.data,
          total: response?.data?.data?.length,
        }));
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchStabilityHistoryData();
  }, [pageState.page, pageState.pageSize]);

  const userColumns = [
    {
      field: "investment_id",
      headerName: "Investment Id",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="rowitem">{params?.row?.investment_id || "N/A"}</div>
        );
      },
    },

    {
      field: "performed_by",
      headerName: "Performed By",
      width: 250,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 250,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <div className="cellWrapper ">
            <div className="profilePic">
              {d?.getHours() + ":" + d?.getMinutes() + ", " + d?.toDateString()}
            </div>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
    },
  ];
  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Suitability Test</h1>
        </div>
        <div className="single">
          <div className="singleContainer">
            <div className="top">
              <div
                className="left"
                style={{ textAlign: "left", boxShadow: "unset" }}
              >
                <div className="topHeading">
                  {" "}
                  <h1
                    className="title"
                    style={{ fontSize: "16px", color: "#333", width: "100%" }}
                  >
                    Corporate Information
                  </h1>
                  <div className="exportBtn-divSec"></div>
                </div>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Company Name:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.corporation_legal_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Email</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.camp_email}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Address:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.registered_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Head Office Address</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.city}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.country_id}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.province}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Type Of Enitity:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.entitytype}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Buisness No:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.business}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Fax</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.fax !== "undefined" &&
                        data?.campaign_detail?.fax !== "null"
                          ? data?.campaign_detail?.fax
                          : "-"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Craax Acoount</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.craax_account !== "undefined" &&
                        data?.campaign_detail?.craax_account !== "null"
                          ? data?.campaign_detail?.craax_account
                          : "-"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Date Of Corp</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.date_of_incorp}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Year Of Corporation</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.how_many_yearsin_business}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="single">
          <div className="singleContainer">
            <div className="top">
              <div
                className="left"
                style={{ textAlign: "left", boxShadow: "unset" }}
              >
                <div className="topHeading">
                  {" "}
                  <h1
                    className="title"
                    style={{ fontSize: "16px", color: "#333", width: "100%" }}
                  >
                    Personal Information
                  </h1>
                </div>

                {data?.investmentAccount === "INDIVIDUAL" ? (
                  <div className="item">
                    <div className="details profile-info">
                      <div className="detailItem">
                        <span className="itemKey">First Name</span>
                        <span className="itemValue">
                          {data?.user?.firstname}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Last Name</span>
                        <span className="itemValue">
                          {data?.user?.lastname}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Investment Account</span>
                        <span className="itemValue">
                          {data?.investmentAccount}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign ID</span>
                        <span className="itemValue">{data?.campaign_id}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.campaign_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Corporate Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.corporation_legal_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Amount</span>
                        <span className="itemValue">{data?.amount}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Currency</span>
                        <span className="itemValue">{data?.currency}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Bank Name</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.bank_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Institutional Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.institution_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Transaction Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.transit_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.account_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Holder</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.account_holder}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Order Number</span>
                        <span className="itemValue">{data?.order_id}</span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Payment Method</span>
                        <span className="itemValue">{data?.paymentOption}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Payment Status</span>
                        <span className="itemValue">{data?.paymentStatus}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="item">
                    <div className="details profile-info">
                      <div className="detailItem">
                        <span className="itemKey">Corporation Name</span>
                        <span className="itemValue">
                          {data?.user?.comp__name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Investment Account</span>
                        <span className="itemValue">
                          {data?.investmentAccount}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign ID</span>
                        <span className="itemValue">{data?.campaign_id}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.corporation_legal_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Amount</span>
                        <span className="itemValue">{data?.amount}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Currency</span>
                        <span className="itemValue">{data?.currency}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Bank Name</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_bank_name
                          }
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Institutional Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_institution_number
                          }
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Transaction Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_transit_number
                          }
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_account_number
                          }
                        </span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Order Number</span>
                        <span className="itemValue">{data?.order_id}</span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Payment Method</span>
                        <span className="itemValue">{data?.paymentOption}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Payment Action</span>
                        <span className="itemValue">{data?.paymentStatus}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="single">
          <div className="singleContainer">
            <div className="top">
              <div
                className="left"
                style={{ textAlign: "left", boxShadow: "unset" }}
              >
                <div className="topHeading">
                  {" "}
                  <h1
                    className="title"
                    style={{ fontSize: "16px", color: "#333", width: "100%" }}
                  >
                    Suitability Test Information
                  </h1>
                  <div className="exportBtn-divSec"></div>
                </div>

                <div className="item">
                  <div className="details profile-info">
                    {suitabilityLoading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <p>Loading suitability test data...</p>
                      </div>
                    ) : suitabilityData && suitabilityData.length > 0 ? (
                      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {suitabilityData.map((item, index) => (
                          <li
                            key={item.id}
                            style={{
                              marginBottom: "25px",
                              padding: "15px",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            <div style={{ marginBottom: "10px" }}>
                              <strong
                                style={{ color: "#333", fontSize: "14px" }}
                              >
                                {index + 1}.{" "}
                                {item.suitability_assestment_question
                                  ?.question || "N/A"}
                              </strong>
                            </div>
                            <div style={{ color: "#555", fontSize: "13px" }}>
                              <strong>Answer:</strong>{" "}
                              {item.suitability_assestment_option?.option_en ||
                                item.user_answer ||
                                "N/A"}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <p>No suitability test data available</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Approval Section */}

                {/* Show message if approverName exists */}
                {data?.is_suitability_accepted == 0 &&
                data?.suitabilityApproveInitiated == 1 ? (
                  <div style={getStatusBoxStyle("accept")}>
                    {`${suitabilityStatus?.approverName} has initiated the acceptance request and it is awaiting approval.`}
                  </div>
                ) : data?.is_suitability_accepted == 1 &&
                  suitabilityStatus?.approverName != null ? (
                  <div style={getStatusBoxStyle("accept")}>
                    {`The ${suitabilityStatus?.approverName} user has already approved this request..`}
                  </div>
                ) : data?.isSuitabilityRejected == 0 &&
                  data?.suitabilityRejectInitiated == 1 ? (
                  <div style={getStatusBoxStyle("reject")}>
                    {`${suitabilityStatus?.rejectorName} has initiated the rejection request and it is awaiting final rejection.`}
                  </div>
                ) : data?.isSuitabilityRejected == 1 &&
                  suitabilityStatus?.rejectorName != null ? (
                  <div style={getStatusBoxStyle("reject")}>
                    {`${suitabilityStatus?.rejectorName} has already rejected this request.`}
                  </div>
                ) : (
                  (!suitabilityStatus?.approverName ||
                    suitabilityStatus?.approverName === null ||
                    suitabilityStatus?.approverName === "") &&
                  (!suitabilityStatus?.rejectorName ||
                    suitabilityStatus?.rejectorName === null ||
                    suitabilityStatus?.rejectorName === "") && (
                    <div
                      style={{
                        marginTop: "30px",
                        padding: "20px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      <h3
                        style={{
                          marginBottom: "20px",
                          color: "#333",
                          fontSize: "16px",
                        }}
                      >
                        Approve Suitability Test
                      </h3>


                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          flexWrap: "wrap",
                        }}
                      >
                        <div style={{ minWidth: "200px" }}>
                          <label
                            style={{
                              display: "block",
                              marginBottom: "5px",
                              fontWeight: "bold",
                              color: "#555",
                            }}
                          >
                            Approved By:
                          </label>
                          <select
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                            disabled={usersLoading}
                            style={{
                              width: "100%",
                              padding: "8px 12px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              fontSize: "14px",
                              backgroundColor: usersLoading
                                ? "#f5f5f5"
                                : "white",
                              cursor: usersLoading ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="">
                              {usersLoading
                                ? "Loading users..."
                                : "Select Approver"}
                            </option>
                            {users.map((user) => (
                              <option key={user.id} value={user.id}>
                                {user.firstname} {user.lastname} -{" "}
                                {user.AdminRole?.name || user.AdminRole?.role} (
                                {user.email})
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          style={{
                            marginTop: "25px",
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <button
                            onClick={handleApprove}
                            disabled={
                              !selectedStatus || approveLoading || rejectLoading
                            }
                            style={{
                              padding: "10px 20px",
                              backgroundColor:
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                                  ? "#28a745"
                                  : "#6c757d",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              cursor:
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                                  ? "pointer"
                                  : "not-allowed",
                              transition: "background-color 0.3s ease",
                            }}
                            onMouseOver={(e) => {
                              if (
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                              ) {
                                e.target.style.backgroundColor = "#218838";
                              }
                            }}
                            onMouseOut={(e) => {
                              if (
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                              ) {
                                e.target.style.backgroundColor = "#28a745";
                              }
                            }}
                          >
                            {approveLoading ? "Processing..." : "Approve"}
                          </button>

                          <button
                            onClick={handleReject}
                            disabled={
                              !selectedStatus || approveLoading || rejectLoading
                            }
                            style={{
                              padding: "10px 20px",
                              backgroundColor:
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                                  ? "#dc3545"
                                  : "#6c757d",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              cursor:
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                                  ? "pointer"
                                  : "not-allowed",
                              transition: "background-color 0.3s ease",
                            }}
                            onMouseOver={(e) => {
                              if (
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                              ) {
                                e.target.style.backgroundColor = "#c82333";
                              }
                            }}
                            onMouseOut={(e) => {
                              if (
                                selectedStatus &&
                                !approveLoading &&
                                !rejectLoading
                              ) {
                                e.target.style.backgroundColor = "#dc3545";
                              }
                            }}
                          >
                            {rejectLoading ? "Processing..." : "Reject"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                )}

                <DataGrid
                  className="datagrid"
                  autoHeight
                  rows={pageState.data}
                  rowCount={pageState.total}
                  rowsPerPageOptions={[10, 30, 50, 70, 100]}
                  pagination
                  page={pageState.page - 1}
                  pageSize={pageState.pageSize}
                  paginationMode="server"
                  onPageChange={(newPage) => {
                    setPageState((old) => ({ ...old, page: newPage + 1 }));
                  }}
                  onPageSizeChange={(newPageSize) =>
                    setPageState((old) => ({ ...old, pageSize: newPageSize }))
                  }
                  columns={userColumns}
                  localeText={{
                    noRowsLabel: "No data available",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewinvestment;
